import { render, staticRenderFns } from "./PutAwayForeground.vue?vue&type=template&id=99484d5a&"
import script from "./PutAwayForeground.vue?vue&type=script&lang=js&"
export * from "./PutAwayForeground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports